<template>
  <div>
    <VContactFilter
      :translate="translate"
      :filters="contactFilters"
      @filters-changed="handleFilterChange"
    />
    <div class="c-contactworkerlist-container">
      <section class="c-contact-worker__hits-heading o-width-limiter">
        <div class="c-contact-numberofcoworkers">
          <span class="c-filter__hits-number">{{
            paginationObject.total
          }}</span>
          {{ this.translate.result }}
        </div>
      </section>
      <div class="c-contact-worker__list o-width-limiter">
        <VContactCoworkerItem
          v-for="(contact, index) in contactWorkers"
          :contact="contact"
          :translate="translate"
          :key="index"
        />
      </div>
      <div class="c-contact-worker__pagination-wrapper">
        <p class="c-contact-worker__pagination-heading">
          {{ this.translate.showing }}
          <span class="c-contact-worker__display-items">{{
            paginationObject.display
          }}</span>
          {{ this.translate.of }}
          <span class="c-contact-worker__total-items">{{
            paginationObject.total
          }}</span>
          {{ this.translate.workers }}
        </p>
        <a
          v-if="paginationObject.display < paginationObject.total"
          @click="loadMore"
          class="c-button c-hero__button--light"
        >
          {{ this.translate.seemoreworkers }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import VContactCoworkerItem from "./VContactCoworkerItem.vue";
import VContactFilter from "../../filter/VContactFilter.vue";
import axios from "axios";

export default {
  name: "VContactCoworkerList",
  props: {
    contacts: {
      type: Array,
    },
    filters: {
      type: Array,
    },
    translationString: {
      type: String,
    },
    pagination: {
      type: Object,
      default: function () {
        return { total: 0, display: 0, currentPage: 1 };
      },
    },
    contactUrl: {
      type: String,
      default: function () {
        return "/sv/kontakta-oss/GetFilteredContacts";
      },
    },
  },
  data() {
    return {
      showEmail: false,
      showNumber: false,
      contactWorkers: this.contacts,
      htmlContent: "",
      apiUrl: "",
      contactFilters: this.filters,
      filterQuery: "",
      paginationObject: this.pagination,
      translate: {},
    };
  },
  methods: {
    handleFilterChange(fullQuery) {
      this.paginationObject.currentPage = 1;
      this.filterQuery = fullQuery;
      this.fetchContacts();
    },
    loadMore() {
      this.paginationObject.currentPage++;
      this.fetchContacts();
    },
    fetchContacts() {
      const queryString = `?CookieRefId=8702&${this.filterQuery}&page=${this.paginationObject.currentPage}`;

      const fullUrl = this.apiUrl + queryString;
      axios
        .get(fullUrl)
        .then((response) => {
          let responseData;
          try {
            responseData = JSON.parse(response.data);
          } catch {
            responseData = response.data;
          }
          /**reading facets */
          if (
            responseData.filter &&
            responseData.filter.facets &&
            responseData.filter.facets.length > 0
          ) {
            this.contactFilters = responseData.filter.facets;
          }
          if (this.paginationObject.currentPage == 1) {
            this.contactWorkers = responseData.contacts;
          } else {
            this.contactWorkers.push(...responseData.contacts);
          }
          this.paginationObject.total = responseData.pagination.total;
          this.paginationObject.display = responseData.pagination.display;
          this.paginationObject.currentPage =
            responseData.pagination.currentPage;
        })
        .catch((error) => {
          console.error("Error fetching contacts:", error);
        });
    },
  },

  components: { VContactCoworkerItem, VContactFilter },
  created() {
    this.translate = JSON.parse(this.translationString);
    this.apiUrl = new URL(this.contactUrl, window.location.href).href;
  },
};
</script>
